module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "idea-card container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "reviews"
  }, [_c('div', {
    staticClass: "container idea-page"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-2 back-remove"
  }, [_c('button', {
    staticClass: "button-back",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('span', [_vm._v("Назад")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-10"
  }, [_c('div', {
    staticClass: "remove-link"
  }), _vm._v(" "), _c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Редактирование идеи")]), _vm._v(" "), _c('form', {
    staticClass: "form-plus-idea",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveIdea($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.idea.title),
      expression: "idea.title"
    }],
    staticClass: "style-input",
    attrs: {
      "type": "text",
      "id": "name",
      "placeholder": "Название идеи"
    },
    domProps: {
      "value": (_vm.idea.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.idea, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), (_vm.isAdmin) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.idea.status_id),
      expression: "idea.status_id"
    }],
    staticClass: "arrow-select style-input",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.idea, "status_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Отклонённая")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("На модерации")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("На голосовании")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("В работе")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15"
    }
  }, [_vm._v("Реализована")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "arrow-select"
  }, [_c('div', {
    staticClass: "style-input turn",
    class: {
      active: _vm.showSelect, empty: !_vm.idea.category_id
    },
    on: {
      "click": function($event) {
        _vm.showSelect = !_vm.showSelect
      }
    }
  }, [_c('span', {
    staticClass: "placeholer-element"
  }, [_vm._v(_vm._s(_vm.categoryName))]), _vm._v(" "), _c('span', {
    staticClass: "btton-push-cat"
  }), _vm._v(" "), (_vm.showSelect) ? _c('ul', {
    staticClass: "select-category"
  }, _vm._l((_vm.categories), function(cat) {
    return _c('li', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.chooseCategory(cat)
        }
      }
    }, [(cat.parent_id) ? _c('span', [_vm._v("   ‐ ")]) : _vm._e(), _vm._v(_vm._s(cat.title) + "\n                                        ")])
  })) : _vm._e()]), _vm._v(" "), (_vm.showSelect) ? _c('div', {
    staticClass: "arrow-select-bg",
    on: {
      "click": function($event) {
        _vm.showSelect = false
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('Editor', {
    attrs: {
      "placeholder": "Описание",
      "content": _vm.idea.description
    },
    on: {
      "change": _vm.setDescription,
      "ready": _vm.setDescription,
      "ctrl-enter": _vm.saveIdea
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-footer"
  }, [_c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('привет'),
      expression: "'привет'"
    }],
    staticClass: "button",
    attrs: {
      "type": "submit",
      "disabled": !_vm.formIsCorrect,
      "title": _vm.formIsCorrect ? '' : 'Заполните, пожалуйста, все поля.'
    }
  }, [_vm._v("\n                                    Сохранить идею\n                                ")]), _vm._v(" "), _c('em', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('test'),
      expression: "'test'"
    }],
    staticClass: "button-help"
  }, [_vm._v("\n                                    Все поля обязательны к заполнению.\n                                ")])])], 1), _vm._v(" "), _vm._m(1, false, false)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "help-blocks"
  }, [_c('ul', [_c('li', {
    staticClass: "help-block-title"
  }, [_vm._v("Похожие темы")]), _vm._v(" "), _c('li', {
    staticClass: "help-block-link"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Удаление аккаунта")])]), _vm._v(" "), _c('li', {
    staticClass: "help-block-link"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Удалить комментарий")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "form-info"
  }, [_c('span', {
    staticClass: "icon"
  }), _vm._v(" Все объявления проходят обязательно модерацию для проверки корректности вводимой информации\n                        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0536cd80","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/IdeaEdit.vue
// module id = 106
// module chunks = 0